import { __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { ComponentService } from "../../../services/component.service";
import { PaymentInstructionsWalletModalComponent } from "../payment-instructions-wallet-modal/payment-instructions-wallet-modal.component";
import { AuthService } from "../../../services/auth.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { BankaccountWhitelistInfoComponent } from "../bankaccount-whitelist-info/bankaccount-whitelist-info.component";
/**
 * Deposit Wallet Modal Component
 */
let DepositWalletModalComponent = class DepositWalletModalComponent {
    constructor(sanitizer, router, location, compService, httpClient, themeService, authService, webSettingsService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.compService = compService;
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.authService = authService;
        this.webSettingsService = webSettingsService;
        this.secondColor = '';
        this.accentColor = '';
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.copied = false;
        this.copiedMemo = false;
        this.sendButtonDisabled = true;
        this.sendButtonClicked = false;
        this.loaded = false;
        this.paymentDetails = {};
        this.displayMessageForMFAReset = false;
        this.walletBlockedRemainingTime = '';
        this.ecurrencyChains = [];
        this.selectedChain = '';
        this.selectedChainName = '';
        this.activeChains = false;
        this.confirmCheckbox = false;
        this.isDepositAddressWarningVisible = false;
        this.bankAccounts = [];
        this.bankAccountsApproved = [];
        this.bankAccountsExpanded = false;
        this.statusApproved = 'APPROVED';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.webSettingsService.getSettings().subscribe(data => {
            this.isDepositAddressWarningVisible = this.webSettingsService.applySettings('WALLET.DEPOSIT_MODAL.ADDRESS_WARNING.VISIBLE');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        if ('walletBlocked' in this.data) {
            if (this.data.walletBlocked) {
                this.displayMessageForMFAReset = true;
                this.authService.fetchUser().then(() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    this.walletBlockedRemainingTime = user.wallet_blocked_remaining_time;
                });
            }
        }
        if (!this.data.walletData.currency.fiat) {
            this.httpClient.get('market/order/get_ecurrency_chains?currency=' + this.data.walletData.currency.verboseId).subscribe((result) => {
                this.ecurrencyChains = result['chains'];
                if (this.ecurrencyChains.length === 1 && !this.isDepositAddressWarningVisible) {
                    this.httpClient.get('wallet/deposit?customerWalletId=' + this.data.walletData.verboseId + '&chain=' + this.ecurrencyChains[0]['chain']['name']).subscribe((data) => {
                        this.depositData = data;
                    });
                }
            });
        }
        else if (this.data.walletData.currency.verboseId == 'EUR') {
            this.httpClient.get('wallet/getfiatdepositpaymentdetails?customerWalletId=' + this.data.walletData.verboseId + '&currency=' + this.data.walletData.currency.verboseId).subscribe((data) => {
                this.paymentDetails = {
                    iban: data['fiatDepositPaymentDetails']['iban'],
                    bic: data['fiatDepositPaymentDetails']['bic'],
                    beneficiaryName: data['fiatDepositPaymentDetails']['account_name'],
                    beneficiaryAddress: data['fiatDepositPaymentDetails']['account_address'],
                    paymentReference: data['fiatDepositPaymentDetails']['payment_number'],
                };
                this.loaded = true;
            });
        }
        else if (this.data.walletData.currency.verboseId === 'RSD') {
            this.httpClient.get('user/getbankaccounts').subscribe((result) => {
                this.bankAccounts = result;
                this.bankAccountsApproved = this.bankAccounts.filter(bankAccount => bankAccount.status === this.statusApproved);
                this.loaded = true;
            });
        }
    }
    ngAfterViewInit() {
        const parentElement = document.querySelector('.check-protocol-text');
        parentElement.appendChild(this.popOver.nativeElement);
    }
    close() {
        this.modal.destroy();
    }
    checkValidation() {
        if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
            this.sendButtonDisabled = true;
            return;
        }
        if (this.bankAccounts.length === 0) {
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 2) {
            this.amount = Number(this.amount.toFixed(2));
        }
        this.sendButtonDisabled = false;
    }
    sendFiat() {
        if (this.sendButtonDisabled) {
            return;
        }
        this.sendButtonClicked = true;
        this.httpClient.get('wallet/getfiatdepositpaymentdetails?customerWalletId=' + this.data.walletData.verboseId + '&currency=' + this.data.walletData.currency.verboseId).subscribe((data) => {
            let user = JSON.parse(localStorage.getItem('user'));
            let address = user.address ? (', ' + user.address) : '';
            let city = user.city ? (', ' + user.city) : '';
            let userDetails = user.name + address + city;
            const paymentDetails = {
                bankAccount: data['fiatDepositPaymentDetails']['bank_account'],
                paymentNumber: data['fiatDepositPaymentDetails']['payment_number'],
                paymentPurpose: data['fiatDepositPaymentDetails']['payment_purpose'],
                paymentModelCode: data['fiatDepositPaymentDetails']['payment_model_code'],
                currency: this.data.walletData.currency.verboseId,
                amount: this.amount
            };
            this.httpClient.post('wallet/getipsqrcode', { paymentDetails: paymentDetails }).subscribe((ipsQRData) => {
                this.sendButtonClicked = false;
                this.close();
                this.compService.openModal(PaymentInstructionsWalletModalComponent, {
                    userDetails: userDetails,
                    merchDetails: ipsQRData['ipsQRData']['merchDetails'],
                    amount: this.amount,
                    currency: this.data.walletData.currency.verboseId,
                    paymentDetails: data['fiatDepositPaymentDetails'],
                    ipsQRCode: ipsQRData['ipsQRData']['ipsQR']['b64data']
                });
            });
        });
    }
    copyToClipboard(address) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (address));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        if (address === this.depositData.address) {
            this.copied = true;
        }
        else if (address === this.depositData.memo) {
            this.copiedMemo = true;
        }
        setTimeout(() => {
            if (address === this.depositData.address) {
                this.copied = false;
            }
            else if (address === this.depositData.memo) {
                this.copiedMemo = false;
            }
        }, 2000);
    }
    openChainsSelect() {
        this.activeChains = !this.activeChains;
    }
    fillChainData(data) {
        this.selectedChainName = data.chain.name;
        this.selectedChain = this.selectedChainName + ' - ' + data.chain.description;
        this.activeChains = false;
        this.confirmCheckbox = false;
        this.depositData = null;
    }
    getDepositAddress() {
        if (!this.confirmCheckbox) {
            this.depositData = null;
            return;
        }
        const chainName = this.ecurrencyChains.length === 1 ? this.ecurrencyChains[0]['chain']['name'] : this.selectedChainName;
        this.httpClient.get('wallet/deposit?customerWalletId=' + this.data.walletData.verboseId + '&chain=' + chainName).subscribe((data) => {
            this.depositData = data;
        });
    }
    expandBankAccounts() {
        this.bankAccountsExpanded = !this.bankAccountsExpanded;
    }
    addNewBankAccount() {
        this.close();
        this.compService.openModal(BankaccountWhitelistInfoComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
};
DepositWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: ComponentService },
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: AuthService },
    { type: WebClientService }
];
__decorate([
    ViewChild('popOver')
], DepositWalletModalComponent.prototype, "popOver", void 0);
DepositWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-deposit-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./deposit-wallet-modal.component.html")).default
    })
], DepositWalletModalComponent);
export { DepositWalletModalComponent };
